import './ultimosVideos.scss';

const videoLogic = (section) => {
    const prev = document.querySelector('.last-videos-container-prev');
    const next = document.querySelector('.last-videos-container-next');
    const step = section.scrollWidth / section.childElementCount;

    prev.style.visibility = 'hidden';
    section.addEventListener('scroll', (e) => {
        prev.style.visibility = (section.scrollLeft < 10) ? 'hidden' : 'visible';
        next.style.visibility = (section.scrollLeft > section.scrollWidth - 1.1*step ) ? 'hidden' : 'visible';
    })


    prev.addEventListener('click', (e)=> {
        e.preventDefault();
        section.scrollLeft= section.scrollLeft - step;
    });

    next.addEventListener('click', (e) => {
        e.preventDefault();
        section.scrollLeft= section.scrollLeft + step;
    });
}

export const ultimosVideos = () => {
    const section = document.querySelector('.last-videos-container');

    if (!section) {
        return ;
    }

    try{
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    videoLogic(section);
                    observer.unobserve(section);
                }
            })
        })
        observer.observe(section);
    } catch (e) {
        //IE surprise
        videoLogic(section);
    }

}
